import * as api from "./client.js";
import type {
  ResearchJobKey,
  ResearchJobSummary,
} from "../pages/Developer/ResearchDataImport/researchJobState.js";

const RESEARCH_JOBS_BASE = "/v1/platform/wp-syncer/research-jobs";

export type ListResearchJobsResponse = {
  jobs: ResearchJobSummary[];
  switches?: Record<string, boolean>;
  requestId: string;
};

export type StartResearchJobResponse = {
  runName: string;
  requestId: string;
};

export const researchJobsService = {
  list(): Promise<ListResearchJobsResponse> {
    return api.get<ListResearchJobsResponse>(RESEARCH_JOBS_BASE);
  },
  start(job: ResearchJobKey, body: { publications?: string[] }): Promise<StartResearchJobResponse> {
    return api.post<StartResearchJobResponse>(`${RESEARCH_JOBS_BASE}/${job}/runs`, body);
  },
};
